export default "__VITE_ASSET__pz831ma4__"